import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-3" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted py-4 text-center"
}
const _hoisted_3 = { class: "font-weight-medium" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-center gap-1"
}
const _hoisted_5 = { class: "text-body-2 font-weight-medium" }
const _hoisted_6 = {
  key: 1,
  class: "text-medium-emphasis text-body-2"
}
const _hoisted_7 = { class: "d-flex align-center gap-2" }
const _hoisted_8 = { class: "text-body-2" }

import { computed } from 'vue'
import type { ApexOptions } from 'apexcharts'
import type { UserTokenBreakdown } from '@/services/adminStatsApi'


export default /*@__PURE__*/_defineComponent({
  __name: 'StatsTokenConsumers',
  props: {
    breakdown: {}
  },
  setup(__props: any) {

const props = __props

const chartHeight = computed(() => Math.max(220, props.breakdown.length * 36))

const chartOptions = computed<ApexOptions>(() => ({
  chart: { toolbar: { show: false } },
  plotOptions: { bar: { horizontal: true, barHeight: '60%' } },
  colors: ['#1a5f4a'],
  dataLabels: { enabled: false },
  xaxis: {
    categories: props.breakdown.map(u => u.name),
    labels: { formatter: (v: string) => '$' + Number(v).toFixed(2) },
  },
  tooltip: { y: { formatter: (v: number) => '$' + v.toFixed(2) } },
}))

const chartSeries = computed(() => [{
  name: 'Maliyet (USD)',
  data: props.breakdown.map(u => u.cost_usd),
}])

const headers = [
  { title: 'Ad Soyad', key: 'name' },
  { title: 'Kullanıcı Adı', key: 'username' },
  { title: 'Dönem Tokeni', key: 'period_tokens' },
  { title: 'Maliyet (USD)', key: 'cost_usd' },
  { title: 'Ort. Puan', key: 'avg_rating' },
  { title: 'Toplam Kota %', key: 'quota_pct' },
]

function quotaColor(pct: number): string {
  if (pct > 80) return 'error'
  if (pct > 50) return 'warning'
  return 'success'
}

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "trezo-card bg-white border-0 shadow-none border-radius mb-0" }, {
    default: _withCtx(() => [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "v-card-header" }, [
        _createElementVNode("h5", { class: "mb-0" }, "Kullanıcı Token Tüketimi")
      ], -1)),
      _createElementVNode("div", _hoisted_1, [
        (!__props.breakdown.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Veri bulunamadı "))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_apexchart, {
                type: "bar",
                height: chartHeight.value,
                options: chartOptions.value,
                series: chartSeries.value
              }, null, 8, ["height", "options", "series"]),
              _createVNode(_component_v_data_table, {
                headers: headers,
                items: __props.breakdown,
                density: "compact",
                class: "mt-4",
                "items-per-page": -1
              }, {
                "item.name": _withCtx(({ item }) => [
                  _createVNode(_component_router_link, {
                    to: `/admin/users/${item.username}/questions`,
                    class: "text-decoration-none font-weight-medium",
                    style: {"color":"#1a5f4a"}
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                "item.period_tokens": _withCtx(({ item }) => [
                  _createTextVNode(_toDisplayString(item.period_tokens.toLocaleString('tr-TR')), 1)
                ]),
                "item.cost_usd": _withCtx(({ item }) => [
                  _createElementVNode("span", _hoisted_3, "$" + _toDisplayString((item.cost_usd ?? 0).toFixed(2)), 1)
                ]),
                "item.avg_rating": _withCtx(({ item }) => [
                  (item.avg_rating != null)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                        _createVNode(_component_v_icon, {
                          size: "14",
                          color: "amber-darken-1"
                        }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-star", -1)
                          ]))]),
                          _: 1
                        }),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(Number(item.avg_rating).toFixed(1)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_6, "—"))
                ]),
                "item.quota_pct": _withCtx(({ item }) => [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_v_progress_linear, {
                      "model-value": item.quota_pct,
                      color: quotaColor(item.quota_pct),
                      height: "8",
                      rounded: "",
                      style: {"min-width":"80px"}
                    }, null, 8, ["model-value", "color"]),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(item.quota_pct) + "%", 1)
                  ])
                ]),
                _: 1
              }, 8, ["items"]),
              _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-caption text-medium-emphasis mt-2" }, " * Dönem Tokeni: seçili dönemdeki tüketim | Toplam Kota %: tüm zamana ait kota kullanımı ", -1))
            ], 64))
      ])
    ]),
    _: 1
  }))
}
}

})